import { ShimmerBlock } from "../../../reporting/components/common/ReportDetailsShimmering";

interface InternalReportTableShimmerProps {
  rows?: number;
  columns?: number;
}

const InternalReportTableShimmer = ({
  rows = 6,
  columns = 8,
}: InternalReportTableShimmerProps) => (
  <div className="w-full animate-pulse">
    <div className="flex items-center gap-4 border-b border-[#E5E5E5] py-3">
      <ShimmerBlock className="h-4 w-32" />
      <div className="ml-auto flex gap-8">
        {Array.from({ length: columns }).map((_, i) => (
          <ShimmerBlock key={i} className="h-4 w-12" />
        ))}
      </div>
    </div>
    {Array.from({ length: rows }).map((_, r) => (
      <div key={r} className="flex items-center gap-4 border-b border-[#E5E5E5] py-4">
        <ShimmerBlock className="h-4 w-40" />
        <div className="ml-auto flex gap-8">
          {Array.from({ length: columns }).map((_, c) => (
            <ShimmerBlock key={c} className="h-4 w-12" />
          ))}
        </div>
      </div>
    ))}
  </div>
);

export default InternalReportTableShimmer;
